<template>
    <div class="content mt20">
       <div class="account-content bgfff">
         <taskOrdersMenu></taskOrdersMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <span class="fl mt5">审核状态：</span>
                <div class="dropdown-toggle fl">
                    <div class="dropdown">
                        <span>{{typeWord}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li @click="OrderType(0)">
                               <a :class="(typeCurrent==0)?'active':''" href="javascript:void(0);">全部</a>
                            </li>
                            <li @click="OrderType(1)">
                               <a :class="(typeCurrent==1)?'active':''" href="javascript:void(0);">审核中</a>
                            </li>
                            <li @click="OrderType(2)">
                               <a :class="(typeCurrent==2)?'active':''" href="javascript:void(0);">通过</a>
                            </li>
                            <li @click="OrderType(3)">
                               <a :class="(typeCurrent==3)?'active':''" href="javascript:void(0);">退回</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="search fr">
                    <div class="search fl">
                        <input type="text" v-model="Searchtitle" class="input-text" name="search" placeholder="请输入媒体号">
                    </div>
                    <button class="btn btn-blue" @click="searcBotton"><i class="icons search-icon"></i></button>
                </div>
            </div>
            <div class="">
                <div class="clearfix listloop-wrap profile" v-for="(item,index) in mediaList" :key="index">
                    <div class="clearfix">
                        <div class="fl profile-img">
                            <img :src="item.cover" width="180" height="100" />
                        </div>
                        <div class="fr profile-btn mt40">
                            <div class="details-a" v-if="item.status==0" @click="toExamine(item.id)"><span :class="[{'color-blue':item.status==0}]">{{item.statusZh}}</span></div>
                            <div class="details-a" v-if="item.status==1||item.status==2"><span :class="item.status==1||item.status==2?'color-gray':''">{{item.statusZh}}</span></div>
                        </div>
                        <div class="profile-info">
                            <h3 class="profile-tit">{{item.title}}</h3>
                            <div class="profile-status">
                                <span class="color_gray time"><i class="icons time-icon"></i>发送时间：{{item.pushTime}}</span>
                                <span class="ml10 read">提交用户：{{item.username}}</span>
                            </div>
                            <p class="profile-art mt30">
                                <span class="fs12">发布媒体号：</span>
                                <span class="ml10 read" v-for="(item1,index) in item.media" :key="index"><i class="icons" :class="[{'wx-icon':item1.type==1},{'wb-icon':item1.type==2},{'tt-icon':item1.type==3}]"></i>{{item1.nickname}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 分页 -->
            <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            
       </div>
       <!-- 查看图片 -->
        <Dialog ref="toExamineModal" :callback="toExamineSave" :modalFoot="false"  width="680" title="审核">
            <div slot="mdBox">
                <h1 class="title">{{orderList.title}}</h1>
                <div class="examine-content" v-html="orderList.content">
                    {{orderList.content}}
                </div>
                <div class="modal-footer mt20 ac">
                    <button class="btn btn-blue" @click="adoptBtn(1)">通过</button>
                    <button class="btn btn-white" id="closeModal" @click="Back">退回</button>
                </div>
            </div>
        </Dialog>
         <Dialog ref="BackModal" :callback="BackSave" :modalFoot="false" width="422" title="退回" type ="alert">
            <div slot="mdBox">
                <div class="form-group1 mt5 clearfix">
                    <div class="input-label">
                        <textarea class="input-text w100" v-model="sel1" rows="31" placeholder="请输入退回理由"></textarea>
                    </div>
                </div>
                <div class="modal-footer mt20 ac">
                    <button class="btn btn-blue" @click="backBtn(2)">确定</button>
                    <button class="btn btn-white" id="closeModal" @click="backClose">取消</button>
                </div>
            </div>
        </Dialog>
  	</div>
</template>
<script>
import Page from '@/components/page'
import Dialog from '@/components/dialog.vue'
import taskOrdersMenu from './taskOrdersMenu.vue'
export default {
    components:{Dialog,Page,taskOrdersMenu},
    data() {
        return {
           mediaList:[],//指令列表
           orderList:'',//指令详情列表
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           typeId:1,//id
           imgUrl:'',//图片url
           typeCurrent:0,//指令类型
           Searchtitle:'',//搜索
           typeWord:'全部',//指令类型文字
           curr:-1,
           pid:'',//指令详情pid
           status:'',//指令详情status
           sel1:'',//退回绑定
           type:1,//通过退回
           tipsText:'请输入退回理由!',//退回提示
        }
    },
    mounted() {
		let that = this;
        if(that.$route.query.type==undefined){
            that.typeWord = '全部'
            that.typeCurrent = 0;
        }else{
            that.typeWord = that.$route.query.type1;
            that.typeCurrent = that.$route.query.type;
            
        }
        
        that.dataAjax(0);
    },
    created() {
		
    },
    methods: {
        adoptBtn(type){//通过按钮
            let that =this;
            that.type = type;
            that.dataAjax3();
            that.$refs.toExamineModal.closeMask();
        },
        Back(){//点击退回
            let that = this;
            that.active = true;
            that.$refs.toExamineModal.closeMask();
            that.$refs.BackModal.showMaskFun();
        },
        backBtn(type){//退回确定
            let that =this;
            that.type = type;
            if(that.sel1 ==''){
                that.$utils.alertText(that.tipsText,140,2000);
                return;
            }
            that.dataAjax3();
            that.$refs.toExamineModal.closeMask();
            that.$refs.BackModal.closeMask();
        },
        backClose(){//退回取消
            let that =this;
            that.sel1 = '';
            that.$refs.toExamineModal.showMaskFun();
            that.$refs.BackModal.closeMask();
        },
        BackSave(){},
        toExamineSave(){},

        toExamine(id){//点击审核弹框
            let that =this;
            that.pid = id;
            that.sel1 ='';
            that.dataAjax2();

        },
        searcBotton(){//搜索
            let that = this;
            if(that.Searchtitle==''){
                return;
            }
            that.dataAjax(0);
        },
        OrderType(type){//指令类型选择
            let that = this;
            that.typeCurrent = type;
            if(type==0){
                that.typeWord = '全部'
            }else if(type==1){
                that.typeWord = '审核中'
            }else if(type==2){
                that.typeWord = '通过'
            }else if(type==3){
                that.typeWord = '退回'
            }
            
            that.$router.push({
                path: '/taskOrders/articleReview',
                query: {
                    type: type,
                    type1:that.typeWord,
                }
            });
            that.typeCurrent = that.$route.query.type;
            that.typeWord = that.$route.query.type1;

            that.dataAjax(0);
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;

            that.dataAjax();
        },
        dataAjax(cPage){//文章发布列表
            let that = this;
            let url = '';
            cPage = 1;
            if(cPage ==0){
                that.currentPage = 1;
            }
            that.$api.post('/audit/list',{page:that.currentPage,pagesize:that.limit,status:that.typeCurrent,title:that.Searchtitle},r=>{
                that.$parent.returnCode(r,function(){
                   that.mediaList=r.data.data;
                   that.totalCount = Number(r.data.total);
              })
            })
       },
       dataAjax2(){//文章发布详情
            let that = this;
            let url = '';
            that.$api.post('/audit/arcdetail',{id:that.pid},r=>{
                that.$parent.returnCode(r,function(){
                    that.orderList=r.data;
                    that.$refs.toExamineModal.showMaskFun();
              })
            })
       },
       dataAjax3(){
           let that =this;
           that.$api.post('/audit/audit',{id:that.pid,status:that.type,remark:that.sel1},r=>{
                that.$parent.returnCode(r,function(){
                    that.dataAjax();
                })
            })
       },

       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/articleReview.vue